/** Коды причин жалобы на анкету актёра (кросс-клиентский контракт с бэком и мобилкой) */
export const ACTOR_COMPLAINT_REASON_CODES = [
  'fake_profile',
  'stolen_photos',
  'false_info',
  'inappropriate_content',
  'spam',
  'other'
] as const;

export type TActorComplaintReason =
  (typeof ACTOR_COMPLAINT_REASON_CODES)[number];

/** Причина, требующая комментария */
export const ACTOR_COMPLAINT_OTHER_REASON: TActorComplaintReason = 'other';

/** Подписи причин жалобы; порядок ключей — порядок в форме */
export const ACTOR_COMPLAINT_REASON_LABELS: Record<
  TActorComplaintReason,
  string
> = {
  fake_profile: 'Фейковая анкета',
  stolen_photos: 'Чужие фото',
  false_info: 'Недостоверные данные',
  inappropriate_content: 'Неприемлемый контент',
  spam: 'Спам или реклама',
  other: 'Другое'
};

/** Предел длины комментария к жалобе (как на бэке) */
export const ACTOR_COMPLAINT_COMMENT_MAX_LENGTH = 1000;

/** Статусы дела по жалобам на анкету: женский род («Новая», «Подтверждена»), порядок — как в селекте */
export const ACTOR_COMPLAINT_CASE_STATUS_LABELS: Record<string, string> = {
  new: 'Новая',
  in_progress: 'В работе',
  confirmed: 'Подтверждена',
  rejected: 'Отклонена'
};

/** apiPath ресурса «Жалобы на анкеты» в admin-v2 */
export const ACTOR_COMPLAINT_CASES_API_PATH =
  'moderation/actor_complaint_cases';

/** Статусы дела как опции селектов (правка статуса, фильтр списка) */
export const ACTOR_COMPLAINT_CASE_STATUS_OPTIONS = Object.entries(
  ACTOR_COMPLAINT_CASE_STATUS_LABELS
).map(([value, label]) => ({ label, value }));

/** Тон пилюли статуса дела — один источник для списка и карточки */
export const ACTOR_COMPLAINT_CASE_STATUS_TONE = {
  new: 'warning',
  in_progress: 'info',
  confirmed: 'success',
  rejected: 'neutral'
} as const;

/** Решённые статусы дела (после них дело можно только вернуть в работу) */
export const ACTOR_COMPLAINT_RESOLVED_STATUSES = ['confirmed', 'rejected'];

/** Действие панели решения: подпись, целевой статус и вид кнопки */
export interface IActorComplaintCaseAction {
  label: string;
  status: string;
  variant: 'primary' | 'success' | 'danger' | 'secondary';
}

/** Кнопки панели решения по текущему статусу дела */
export const ACTOR_COMPLAINT_CASE_ACTIONS: Record<
  string,
  IActorComplaintCaseAction[]
> = {
  new: [
    { label: 'Взять в работу', status: 'in_progress', variant: 'primary' },
    { label: 'Подтвердить', status: 'confirmed', variant: 'success' },
    { label: 'Отклонить', status: 'rejected', variant: 'danger' }
  ],
  in_progress: [
    { label: 'Подтвердить', status: 'confirmed', variant: 'success' },
    { label: 'Отклонить', status: 'rejected', variant: 'danger' },
    { label: 'Вернуть в новые', status: 'new', variant: 'secondary' }
  ],
  confirmed: [
    { label: 'Вернуть в работу', status: 'in_progress', variant: 'secondary' }
  ],
  rejected: [
    { label: 'Вернуть в работу', status: 'in_progress', variant: 'secondary' }
  ]
};
